module.exports = {
    graphqlUrl: process.env.GRAPHQL_URL || "http://localhost:3000/graphql",
};
